type ageObject = {
  index: number
  value: number
}

export function sumAgesFromString(ages: string): number {
  return ages
    ? ages.split(',').reduce((prev: number, value: string) => prev + parseInt(value, 10), 0)
    : 0
}

export function convertAgesToArray(ages: string): Array<ageObject> {
  return ages
    ? ages.split(',').map((age: string, index: number) => ({ index, value: parseInt(age) }))
    : []
}

export function convertAgesToString(ages: Array<ageObject>): string {
  return ages?.length ? ages.map(age => age.value).join(',') : ''
}

export function areSameAges(ages: Array<ageObject>, newAges: Array<ageObject>): boolean {
  return ages.every(
    (age: ageObject, index: number) =>
      age.value === newAges.find((newAge: ageObject) => newAge.index === index)?.value
  )
}
